import styles from '@features/cms/components/pages/TableBlock/TableBlock.styles';
import { ITableBlock } from '@features/cms/typescript';
import theme from '@styles/theme';
type PropsType = {
  data: ITableBlock;
  defaultBackground?: string;
};
const TableBlock = ({
  data,
  defaultBackground = theme.rawColors.neutralWhite
}: PropsType) => {
  const {
    table,
    marginTop,
    marginBottom,
    code,
    background
  } = data;
  const renderCellContent = (text: string) => {
    if (typeof text !== 'string') return text;
    // Zamień tylko <br>, <br/>, <br /> na elementy React
    const parts = text.split(/(<br\s*\/?>)/i);
    return parts.map((part, index) => {
      if (/^<br\s*\/?>$/i.test(part)) {
        return <br key={index} />;
      }
      return part;
    });
  };
  const renderTable = () => {
    if (!table.length) return null;
    return <table id={code} data-testid="TableBlock">
        {table.map((row, rowIndex) => {
        if (!row?.length) return null;
        const keyRow = rowIndex.toString();
        return <tr key={keyRow} data-testid={`TableBlock-row-${rowIndex}`}>
              {row.map((colValue, colIndex) => {
            const keyCol = `${keyRow}-${colIndex}`;
            return <td key={keyCol}>{renderCellContent(colValue)}</td>;
          })}
            </tr>;
      })}
      </table>;
  };
  return <div sx={styles.container(marginTop, marginBottom, background || defaultBackground)}>{renderTable()}</div>;
};
export default TableBlock;